import { TextField, FormControl } from '@mui/material';
import { BuyerOptionProps } from '.';

import React, { useEffect, useState } from 'react';
import LinkifyText from '../../common/LinkifyText';
import { containsEmail, isAddressField } from '../../../utils/address';

interface GenericTextBuyerOptionProps extends BuyerOptionProps {
  textFieldMaxLength?: number,
  multiline?: boolean,
  preserveRawText?: boolean
}

export default function GenericText(props: GenericTextBuyerOptionProps) {
  const [ textValue, setTextValue ] = useState(props.currentValue || '');
  const textFieldMaxLength = props.textFieldMaxLength ? props.textFieldMaxLength : 255;
  const onErrorChange = props.onErrorChange;

  const isEmailInAddress = isAddressField(props.optionKey) && containsEmail(textValue);

  useEffect(() => {
    onErrorChange && onErrorChange(props.id, isEmailInAddress);
  }, [onErrorChange, props.id, isEmailInAddress]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = props.preserveRawText ? e.target.value : e.target.value?.trimStart();
    setTextValue(newValue);

    if (props.onDetailChange) {
      props.onDetailChange(
        props.optionKey,
        newValue,
        props.isEditMode ? props.buyerDetailId : props.id
      );
    }
  }


  return (
    <FormControl fullWidth>
      <TextField
        required={props.isRequired}
        value={textValue}
        disabled={props.isDisabled}
        error={isEmailInAddress}
        helperText={isEmailInAddress ?
          'Please enter a street address, not an email address.' :
        textValue.length >= textFieldMaxLength ?
          `Maximum length of field is ${textFieldMaxLength} characters. Please shorten.` :
        <LinkifyText text = {props.description} variant="body2"/>}
        inputProps={{ maxLength: textFieldMaxLength }}
        multiline={props.multiline}
        onChange={handleChange}
        label={props.label} />
    </FormControl>
  );
}
